
export const styles = theme => ({
    container : {
        display : 'flex',
    },
    searchPaper : {
      [theme.breakpoints.up('md')]: {
        //minWidth: (theme.breakpoints.values.md - theme.spacing(1) * 12),
      },
      [theme.breakpoints.up('lg')]: {
          //minWidth: (theme.breakpoints.values.md /2),
          //maxWidth: (theme.breakpoints.values.md),
          //marginLeft: theme.spacing(1) * 30,
          //marginRight: theme.spacing(1) * 30
      },        
      [theme.breakpoints.down('sm')]: {
        //minWidth: (window.innerWidth - (theme.spacing(5))),
        //maxWidth: (window.innerWidth - (theme.spacing(5))),
      }
    },
    card : {
        // margin: theme.spacing(1),
        /*
        [theme.breakpoints.up('md')]: {
            minWidth: (theme.breakpoints.values.md /2),
        },
        [theme.breakpoints.up('lg')]: {
            minWidth: (theme.breakpoints.values.lg /3),
        },
        [theme.breakpoints.down('sm')]: {
          minWidth: theme.breakpoints.values.sm / 2,
        }
        */
    },
    cardHeader : {
        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 1px 0px',
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
        alignItems : 'center'
    },
    avatar : {
        backgroundColor: theme.palette.secondary.light,
    },
    avatar2 : {
        backgroundColor: 'white',
        borderColor: theme.palette.secondary.light
    },    
    cardContent : {
        width : '100%',
        //alignItems: 'baseline',
        //marginBottom: theme.spacing(1) * 2,
    },
    listItem : {
        display: 'flex',
        flexDirection : 'column',
        justifyContent: 'flex-start',
        width: '100%',
        cursor: 'pointer'
    },
    margin : {
        margin : theme.spacing(2),
        display: 'flex'
    },    
    searchPanel : {
        display : 'flex',
        flexDirection : 'row',
        marginTop : theme.spacing(1),
        marginBottom : theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',    
    },
    searchButton : {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    selectFormControl: {
        minWidth: 200,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },    
    selectValue: {
        transform: 'translate(14px, -6px) scale(0.75)', 
        backgroundColor: 'white !important',
        paddingLeft: '4px', 
        paddingRight: '4px'
    },
    selectNoValue : {
    },    
    selectField : {
        marginLeft: theme.spacing(3),
    },    
    textField : {
        marginLeft: theme.spacing(2),
        padding: "10px"
    },
    textFieldAutoSuggest : {
        width: '300px',
    },
    textFieldAutoSuggest2 : {
        width: '200px',
    },     
    paginator: {
        height: '55px',
        zIndex: 2,
        backgroundImage: 'linear-gradient(#efefef, #fff)',
        transform: 'translate3d(0px, -1px, 0px)',
        borderColor: '#d3d3d3',
        borderStyle: 'solid',
        borderWidth: '1px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    paginatorRoot: {
        marginTop: 3,
        marginBottom: 3,
        marginRight: 10,
        alignItems: 'center',
        alignContent: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around'
    },
    p10:{
        paddingTop: '10px',
        paddingBottom: '10px',
    },  
    pt10 : {
        paddingTop: '10px',
    },  
    pt20:{
        paddingTop: '20px',
    },
    pt40:{
        paddingTop: '40px',
    },    
    pb20:{
        paddingBottom: '20px',
    },    
    pl20: {
        paddingLeft: '20px',
    },
    pl40: {
        paddingLeft: '40px',
    },    
    pgnFormControl: {
        margin: '0px',
        padding: '0px 0px'
    },
    noPad: {
        padding: '0px'
    },
    flexRow:{
        display: 'flex',
        flexDirection: 'row',       
    },
    flexColumn:{
        display: 'flex',
        flexDirection: 'column',  
    },
    alignCenter: {
        alignItems: 'center',
    },
    flexTop:{
        justifyContent: 'flex-start',
        alignItems: 'top', 
    },
    spaceAround:{
        justifyContent: 'space-around',
    },
    spaceBetween: {
        justifyContent: 'space-between',
    },
    flexStart:{
        justifyContent: 'flex-start',
    },
    flexRowBetween:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',        
    },
    flexRowStart: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',        
    },
    flexRowStartAlignTop: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'top',        
    },    
    flexRowStartAlignEnd: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
    },
    flexRowEnd: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    flexRowCenter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    flexColumnStart: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
    },
    flexColumnCenter: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    paperForm: {
        padding: theme.spacing(3),
        backgroundColor: 'transparent'
    },
    providersHdr:{
        padding:'15px', 
        backgroundColor:'#e3f2fd'        
    },
    suggestionContainer: {
        position: 'relative',
        paddingLeft: '10px',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
        
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
        wordWrap:'break-word',
    },
    zoomReveal: {
        height: "100%"
    },
    tableHeaderStyle: {
        color: theme.palette.primary.main,
        fontSize: "0.75rem",
        fontWeight: "bold",
        padding: "4px 4px 4px 4px"
    }
});
/**
        maxWidth: '350px',
        [theme.breakpoints.up('md')]: {
            maxWidth: '400px',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '500px',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '300px',
        }
 */